import React from "react";
import Heading from "./Heading";
import { FaInfoCircle, FaPlus, FaTrash } from "react-icons/fa";
import { Button } from "@mui/material";
import TextModal from "../preview/modals/TextModal";
import CommentModal from "../preview/modals/CommentModal";
import DropdownMenu from "../DropdownMenu";
import AttachmentField from "../preview/AttachmentField";

const defaultProps = {
    elementId: '',
    ccId: '',
    element: {},
    label: "Label Here",
    value: [],
    onChange: () => {},
    disabled: false,
};

const DocumentsSelectorField = (rawProps) => {

    const props = {...defaultProps, ...rawProps};

    return (
        <>
            <div className="d-flex align-items-center mb-2">
                <Heading size="h6" font="Sohne-Buch" label={props.label} />
                <div className="ms-auto">
                    <TextModal
                        title="Instructions"
                        icon={<FaInfoCircle />}
                        content={""}
                        className="me-2"
                        size={"small"}
                    />
                    <CommentModal elementId={props.elementId} ccId={props.ccId} />
                </div>
            </div>
            <AttachmentField
                elementId={props.elementId}
                ccId={props.ccId}
                categoryId={props.element.properties.category_id ?? ""}
                subcategoryId={props.element.properties.subcategory_id ?? ""}
                typeId={props.element.properties.type_id ?? ""}
                isReadOnly={props.disabled}
                label={'evidence'}
            />
        </>
    );
};

export default DocumentsSelectorField;
